import { RpmAssessmentViewStatusQueryValue } from '@csp/csp-common-assessment';
import { EnumUtil } from '@csp/csp-common-enum-util';
import { EmailJobConfig, Maybe } from '@csp/csp-common-model';

export type SymptomMonitoringEmailJobConfig = EmailJobConfig & {
  includeReviewStatus: Maybe<RpmAssessmentViewStatusQueryValue>;
};

type In = Parameters<typeof EmailJobConfig.from>[0] & {
  includeReviewStatus: Maybe<string>;
};

const from = ({
  code,
  cronPattern,
  roles,
  patientColumnLink,
  groupBy,
  includeReviewStatus,
}: In): SymptomMonitoringEmailJobConfig => {
  const emailJobConfig = EmailJobConfig.from({
    code,
    cronPattern,
    groupBy,
    patientColumnLink,
    roles,
  });

  const parsedIncludeReviewStatus = EnumUtil.fromMaybeString<RpmAssessmentViewStatusQueryValue>(
    includeReviewStatus,
    RpmAssessmentViewStatusQueryValue,
  );

  return {
    ...emailJobConfig,
    includeReviewStatus: parsedIncludeReviewStatus,
  };
};

export const SymptomMonitoringEmailJobConfig = {
  from,
};
